

export const setSessionID = () => {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
};

// Enter Full Screen
export function _enterFullScreen() {
    if(document.body.requestFullscreen) {
        document.body.requestFullscreen();
    } else if(document.body.webkitRequestFullScreen ) {
        document.body.webkitRequestFullscreen();
    } else if(document.body.mozRequestFullScreen) {
        document.body.mozRequestFullscreen();
    } else if(document.body.msRequestFullscreen) {
        document.body.msRequestFullscreen();
    }
};

// Exit Full Screen
export function _exitFullScreen() {
    // document.body.exitFullscreen();
    if (document.fullscreenElement) {
        document.exitFullscreen();
    } else if (document.webkitFullscreenElement) {
        document.webkitExitFullscreen();
    } else if (document.mozFullScreenElement) {
        document.mozCancelFullScreen();
    } else if (document.msFullscreenElement) {
        document.msExitFullscreen();
    }
};

export const _billboard_status_controller = (billboard_list, viewer_type) => {
    // console.log('status::', billboard_status, billboard_list, type, viewer_type)
    // add billboard_status conditional
    // if(viewer_type === "levar_debut") return false; // levar_debut
    if(viewer_type !== "billboard_display" ) return false;
    if(!billboard_list || billboard_list.length < 1) return false; // has billboard lists in payload
    return true;
}

export const _variant_switch_status_controller = (options, viewer_type) => {
    if(viewer_type !== "variant_switch_display" ) return false;
    if(options.length < 2) return false; // has multiple options in payload
    return true;
}

export const _billboard_variant_switch_status_controller = (billboard_list, options, viewer_type) => {
    if(viewer_type !== "billboard_variant_switch_display" ) return false;
    if(!billboard_list) return false; // has billboard lists in payload
    if(options.length < 2) return false; // has multiple options in payload
    return true;
}

export const extractVariantId = (variant_id) => {
    if(variant_id.includes('bco_')) {
        return { variant_id: variant_id.substring(4), variant_type: "bco" }
    } else if(variant_id.includes('cus_')) {
        return { variant_id: variant_id, variant_type: "cus" } 
    } else {
        return { variant_id: variant_id, variant_type: "shopify" }
    }
}

// Default levAR Text Settings
export const default_levar_text_settings = {
    custom_text_status: false,
    default_text_font: "Overpass",
    viewer_button: {
        button_color: "#2196F3",
        button_text_color: "#ffffff",
        button_text: "view in my space",
        button_position: "center",
    },
    mobile_ar_button: {
        button_color: "#f1f1f1",
        button_text_color: "#525150",
        button_text: "See in AR",
        button_position: "flex-start",
    }
}

export const setBooleanValue = (value) => {
    if(value === undefined) {
        return false
    } else if(value === 'true') {
        return true 
    } else {
        return false
    }
}

export const _setCustomBannerURL = (variant_id, variant_type) => {
    switch(variant_type){
        case "bco":
            return `&custom=https://actar.levar.io/index.html/?variant_id=bco_${variant_id}&customHeight=small`; // BigCommerce
        default:
            return `&custom=https://actar.levar.io/index.html/?variant_id=${variant_id}&customHeight=small`;
    }
};

// REDIRECT URL FOR ADD TO CART
export const setARCartURL = (variant_id, vList, variant_type, ar_cta_type) => {
    if(!variant_id && !vList && !variant_type) return;
    // console.log('vList[variant_id].referer', vList[variant_id].referer)
    // put conditional for if will go directly into cart
    let levar_cart_url = vList[variant_id].referer;
    // console.log('variant_type', variant_type);
    // console.log('ar_cta_type', ar_cta_type);
    // && ar_cta_type === "add_to_cart"
    if (variant_type === 'bco') {
        var variant_sku = vList[variant_id].sku;
        if (variant_sku) {
            levar_cart_url = levar_cart_url.split('.com/')[0]+'.com/cart.php?action=add&sku='+variant_sku;
        }
    } else if (variant_type === 'shopify' && ar_cta_type === "add_to_cart") {
        levar_cart_url = levar_cart_url.split('.com/')[0]+'.com/cart/'+variant_id+':1';
    } else if (variant_type === 'cus') {
        
    } else {
        // levar_cart_url = vList[variant_id].levar_exit_url; // Basic Version
        levar_cart_url = vList[variant_id].referer;
    }
    // console.log('levar_cart_url', levar_cart_url)
    // if (variant_type === 'bco') {
    //     var variant_sku = vList[variant_id].sku;
    //     if (variant_sku) {
    //         arRedirectURL = vList[variant_id].levar_exit_url.split('.com/')[0]+'.com/cart.php?action=add&sku='+variant_sku;
    //     }
    // } else {
    //     if(vList[variant_id].levar_exit_url) {
    //         arRedirectURL = vList[variant_id].levar_exit_url.split('.com/')[0]+'.com/cart/'+variant_id+':1';
    //     } else if(vList[variant_id].referer) {
    //         arRedirectURL = vList[variant_id].referer.split('.com/')[0]+'.com/cart/'+variant_id+':1';
    //     }
    // }
    return levar_cart_url;
}

export const buildOptions = (vList, params) => {
    if(params.viewer_type !== "variant_switch_display") return // return if no variant switch display params

    let product_options = []

    Object.keys(vList).forEach((variantID) => {
        let currVar = vList[variantID]
        
        if(product_options.length < 1) {
            const seperated_options = currVar.options.reduce((acc, o, i) => {
                let current_option = {
                    product_id: currVar.product_id,
                    name: o[0],
                    position: i,
                    values: []
                }
                acc.push(current_option)
                return acc
            }, [])
            product_options.push(...seperated_options)
        }

        currVar.options.forEach(option => {
            if(option[2]) {
                // console.log(option[2], 'fefe')
            }
            let found_name = product_options.find(n => n.name === option[0]);
            let valueExists;
            if (found_name) {
                valueExists = found_name.values.some(val => val.label === option[1])
                if(!valueExists) {
                    found_name.values.push({ label: option[1], texture: option[2] ? option[2] : null })
                }
            }
        })
    })

    console.log('product_options', product_options)
    return product_options;
}

// export const create_ar_url = (intent, store_id, vList, variant_id, variant_type, custom_banner) => {
//     let finalUrl = "";

//     if(intent === 'willQL') {
//         const dt = `${BUCKET_URL}${store_id}/${vList[variant_id].bundle}/${vList[variant_id].ardt}.usdz`;
//         const scalingOn = '#allowsContentScaling=0';
//         const custom_cta = custom_banner ? _setCustomBannerURL(variant_id, variant_type) : ""  
//         finalUrl = `${dt}${scalingOn}${custom_cta}`;
//     } else if(intent === 'willSV') {
//         let levar_intent = "ar_preferred" // Intent
//         let browser_fallback_url = "https://developers.google.com/ar;" // if Google Play Services for AR isn't present, Scene Viewer launches the URL you set in the
//         let package_scene = "com.google.android.googlequicksearchbox"; // ar_only => com.google.ar.core
        
//         let glbURL = `${BUCKET_URL}${store_id}/${vList[variant_id].bundle}/${vList[variant_id].ardt}.glb`; // GLB URL

//         let sceneURL = `#Intent;scheme=https;package=${package_scene};action=android.intent.action.VIEW;S.browser_fallback_url=${browser_fallback_url}`
//         finalUrl = `intent://arvr.google.com/scene-viewer/1.1?file=${glbURL}&mode=${levar_intent}&resizable=false${sceneURL}end;`; // v 1.1                        
//     }

//     return finalUrl;
// };
// export function _cleanFont(text_settings) {
//     // console.log("before <><><><> ", text_settings);
//     let both = [...text_settings.default_text_font.split(":")];
//     // Saira+Condensed:wght@100;300;600;900

//     let dividerSymbol = text_settings.default_text_font.indexOf("@")
//     if(dividerSymbol !== -1) {
//         // for font weight
//         // let intermediate = text_settings.default_text_font.substr(dividerSymbol + 1, 100);
//         // let res = intermediate.split(';');
//         // let fontWeights = [...res];
//         // console.log("weights ::", fontWeights)
//     };
//     text_settings.default_text_font = both[0].replace(/\+/g, ' ');
//     console.log(text_settings.default_text_font)
//     return text_settings
// };
